import { render, staticRenderFns } from "./SwitchDayButtons.vue?vue&type=template&id=22fb9af6&scoped=true&"
import script from "./SwitchDayButtons.vue?vue&type=script&lang=js&"
export * from "./SwitchDayButtons.vue?vue&type=script&lang=js&"
import style0 from "./SwitchDayButtons.vue?vue&type=style&index=0&id=22fb9af6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fb9af6",
  null
  
)

export default component.exports